<template>
  <div style="padding:10px;">
    <van-overlay :show="show">
        <div class="wrapper">
          <van-loading size="32px" color="#fff" type="spinner" vertical>{{loading}}</van-loading>
        </div>
      </van-overlay>

  <van-empty class="custom-image" image="https://saha.projemikro.com/logo/vander.jpg" description="Crm V.1.0.1"/>
<van-form style="margin-top:10px;" >
  <van-field
    v-model="username"
    name="Username"
    label="Kullanıcı Adı"
    placeholder="Kullanıcı Adı"
    :rules="[{ required: true, message: 'Kullanıcı Adı Gerekli' }]"
  />
  <van-field
    v-model="password"
    type="password"
    name="Password"
    label="Şifre"
    placeholder="Şifre"
    :rules="[{ required: true, message: 'Şifre Gerekli' }]"
  />
  <div style="margin: 16px;">
    <van-button block type="danger"  native-type="submit" @click="handleSubmit">
      Giriş Yap
    </van-button>
  </div>
</van-form>
<!-- <div style="font-size:20px; text-align:center">{{error}}</div> @submit="handleSubmit"-->
</div>
</template>

<script>
import { router } from '@/router';
//import { userService } from '../_services';

export default {
    data () {
        return {
          show:false,
          loading:'',
            username: '',
            password: '',
            submitted: false,
            returnUrl: '', 
            error: {
              text:'',
              status : false
            },
        }
    },
    created () {
        this.returnUrl = this.$route.query.returnUrl || '/';
        this.show = false
    },
    methods: {
        handleSubmit (e) {
            this.submitted = true;
            const { username, password } = this;

            if (!(username && password)) {
                return;
            }
            this.loading = "Bekleyiniz"
            this.show = true
            this.$helper.login(username, password)
                .then(res => {
                  this.loading = "Cariler yükleniyor"
                  this.$store.commit('setHesap', res.data)
                  this.$store.dispatch("carilist",this.$request).then((cari) => {
                    if (cari.status) {
                      if (this.returnUrl== '/oturum') {
                              router.push("/")
                            }
                            else {
                              router.push(this.returnUrl)
                            }
                      //  this.loading = "Ürünler Yükleniyor"
                      //   this.$store.dispatch("stoklist",this.$request).then((stok) => {
                      //     console.log(stok.status)
                      //     if (stok.status) {
                      //       this.show = false
                      //       if (this.returnUrl== '/oturum') {
                      //         router.push("/")
                      //       }
                      //       else {
                      //         router.push(this.returnUrl)
                      //       }
                      //     }
                      //     else{
                      //       this.show = false
                      //       this.$notify({ type: 'danger', message: stok.mesaj });
                      //     }
                      // }).catch((err)=>{
                      //   this.show = false
                      //   this.$notify({ type: 'danger', message: err.mesaj });
                      // })  
                    }
                    else {
                      this.show = false
                      this.$notify({ type: 'danger', message: cari.mesaj });
                    }
                                   
                  }).catch((err)=>{
                    this.show = false
                    this.$notify({ type: 'danger', message: err.mesaj });
                  })
                })
                .catch (err => {
                  this.show=false;
                  this.$notify({ type: 'danger', message: err.msg });
              })
        }
    }
};
</script>
<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue